// extracted by mini-css-extract-plugin
export default {"upload-file-form":"UploadFileScreen_upload-file-form__4pnz0","form-actions":"UploadFileScreen_form-actions__BkMzV"};